import clsx from 'clsx';

import { useTranslation } from '../../i18n/useTranslation.js';

const STATUS_TO_VARIANT = {
  ACTIVE: 'success',
  POSTED: 'success',
  PAID: 'success',
  FULFILLED: 'success',
  CONFIRMED: 'info',
  PARTIAL: 'warning',
  DRAFT: 'neutral',
  SENT: 'info',
  ACCEPTED: 'success',
  REJECTED: 'danger',
  CANCELLED: 'danger',
  BLOCKED: 'danger',
  OVERDUE: 'danger',
  INACTIVE: 'neutral',
  PENDING: 'warning',
  PENDING_APPROVAL: 'warning',
  APPROVED: 'success',
  CONVERTED: 'success',
  INVOICED: 'info',
  CLOSED_WON: 'success',
  CLOSED_LOST: 'danger',
  RECEIVED: 'success',
  TERMINATED: 'danger',
  ON_LEAVE: 'warning',
  SUSPENDED: 'danger',
  OPEN: 'info',
  PAUSED: 'warning',
  CLOSED: 'neutral',
  HIRED: 'success',
};

export function Badge({ status, variant, children, className }) {
  const { t } = useTranslation();
  const v = variant || STATUS_TO_VARIANT[status] || 'neutral';
  const label = children ?? (status ? t(`status.${status}`) : null);
  return <span className={clsx('badge', v, className)}>{label}</span>;
}
